import {Exchange} from "../../../instruments/exchange/Exchange";
import {CodeAndExchange} from "../../../instruments/types/CodeAndExchange";

type AsxHybrids = ReadonlyArray<CodeAndExchange>;

export const hyrbrids: AsxHybrids = [
    { code: "AAEAP", exchange: Exchange.ASX },
    { code: "AAEAS", exchange: Exchange.ASX },
    { code: "AAEAU", exchange: Exchange.ASX },
    { code: "AAEAW", exchange: Exchange.ASX },
    { code: "AAEAY", exchange: Exchange.ASX },
    { code: "AAZPA", exchange: Exchange.ASX },
    { code: "AAZPB", exchange: Exchange.ASX },
    { code: "ABSG", exchange: Exchange.ASX },
    { code: "ABSPA", exchange: Exchange.ASX },
    { code: "ABZAO", exchange: Exchange.ASX },
    { code: "ADBPA", exchange: Exchange.ASX },
    { code: "ADBPB", exchange: Exchange.ASX },
    { code: "AEYG", exchange: Exchange.ASX },
    { code: "AFIG", exchange: Exchange.ASX },
    { code: "AFOA", exchange: Exchange.ASX },
    { code: "AGIG", exchange: Exchange.ASX },
    { code: "AHUG", exchange: Exchange.ASX },
    { code: "AHUGA", exchange: Exchange.ASX },
    { code: "ALNPA", exchange: Exchange.ASX },
    { code: "AMMG", exchange: Exchange.ASX },
    { code: "AMPPA", exchange: Exchange.ASX },
    { code: "AMPPB", exchange: Exchange.ASX },
    { code: "AMZG", exchange: Exchange.ASX },
    { code: "AMZGA", exchange: Exchange.ASX },
    { code: "AN3PF", exchange: Exchange.ASX },
    { code: "AN3PG", exchange: Exchange.ASX },
    { code: "AN3PH", exchange: Exchange.ASX },
    { code: "AN3PI", exchange: Exchange.ASX },
    { code: "AN3PJ", exchange: Exchange.ASX },
    { code: "AN3PK", exchange: Exchange.ASX },
    { code: "AN3PL", exchange: Exchange.ASX },
    { code: "ANZPA", exchange: Exchange.ASX },
    { code: "ANZPB", exchange: Exchange.ASX },
    { code: "ANZPC", exchange: Exchange.ASX },
    { code: "ANZPD", exchange: Exchange.ASX },
    { code: "ANZPE", exchange: Exchange.ASX },
    { code: "AOEGA", exchange: Exchange.ASX },
    { code: "APNG", exchange: Exchange.ASX },
    { code: "ARHG", exchange: Exchange.ASX },
    { code: "AUNG", exchange: Exchange.ASX },
    { code: "AUUPA", exchange: Exchange.ASX },
    { code: "AUXAK", exchange: Exchange.ASX },
    { code: "AVDG", exchange: Exchange.ASX },
    { code: "AXOG", exchange: Exchange.ASX },
    { code: "AYIG", exchange: Exchange.ASX },
    { code: "AYUAB", exchange: Exchange.ASX },
    { code: "AYUPA", exchange: Exchange.ASX },
    { code: "AZZGA", exchange: Exchange.ASX },
    { code: "BBCGA", exchange: Exchange.ASX },
    { code: "BBCGC", exchange: Exchange.ASX },
    { code: "BCYG", exchange: Exchange.ASX },
    { code: "BECG", exchange: Exchange.ASX },
    { code: "BENPA", exchange: Exchange.ASX },
    { code: "BENPB", exchange: Exchange.ASX },
    { code: "BENPC", exchange: Exchange.ASX },
    { code: "BENPD", exchange: Exchange.ASX },
    { code: "BENPE", exchange: Exchange.ASX },
    { code: "BENPF", exchange: Exchange.ASX },
    { code: "BENPG", exchange: Exchange.ASX },
    { code: "BENPH", exchange: Exchange.ASX },
    { code: "BENPI", exchange: Exchange.ASX },
    { code: "BEPPA", exchange: Exchange.ASX },
    { code: "BKWPA", exchange: Exchange.ASX },
    { code: "BNBG", exchange: Exchange.ASX },
    { code: "BNEAK", exchange: Exchange.ASX },
    { code: "BNEAM", exchange: Exchange.ASX },
    { code: "BNEAQ", exchange: Exchange.ASX },
    { code: "BNEAS", exchange: Exchange.ASX },
    { code: "BNEAU", exchange: Exchange.ASX },
    { code: "BNLG", exchange: Exchange.ASX },
    { code: "BNTGA", exchange: Exchange.ASX },
    { code: "BOQPA", exchange: Exchange.ASX },
    { code: "BOQPB", exchange: Exchange.ASX },
    { code: "BOQPC", exchange: Exchange.ASX },
    { code: "BOQPD", exchange: Exchange.ASX },
    { code: "BOQPE", exchange: Exchange.ASX },
    { code: "BOQPF", exchange: Exchange.ASX },
    { code: "BOQPG", exchange: Exchange.ASX },
    { code: "BPCPA", exchange: Exchange.ASX },
    { code: "BPKG", exchange: Exchange.ASX },
    { code: "CAAG", exchange: Exchange.ASX },
    { code: "CAMDA", exchange: Exchange.ASX },
    { code: "CAMDB", exchange: Exchange.ASX },
    { code: "CAMG", exchange: Exchange.ASX },
    { code: "CAMGA", exchange: Exchange.ASX },
    { code: "CAMPA", exchange: Exchange.ASX },
    { code: "CBAPA", exchange: Exchange.ASX },
    { code: "CBAPB", exchange: Exchange.ASX },
    { code: "CBAPC", exchange: Exchange.ASX },
    { code: "CBAPD", exchange: Exchange.ASX },
    { code: "CBAPE", exchange: Exchange.ASX },
    { code: "CBAPF", exchange: Exchange.ASX },
    { code: "CBAPG", exchange: Exchange.ASX },
    { code: "CBAPH", exchange: Exchange.ASX },
    { code: "CBAPI", exchange: Exchange.ASX },
    { code: "CBAPJ", exchange: Exchange.ASX },
    { code: "CBAPK", exchange: Exchange.ASX },
    { code: "CBAPL", exchange: Exchange.ASX },
    { code: "CBAPM", exchange: Exchange.ASX },
    { code: "CBDG", exchange: Exchange.ASX },
    { code: "CBHG", exchange: Exchange.ASX },
    { code: "CBHGA", exchange: Exchange.ASX },
    { code: "CCIG", exchange: Exchange.ASX },
    { code: "CDDG", exchange: Exchange.ASX },
    { code: "CGFPA", exchange: Exchange.ASX },
    { code: "CGFPB", exchange: Exchange.ASX },
    { code: "CGFPC", exchange: Exchange.ASX },
    { code: "CGFPD", exchange: Exchange.ASX },
    { code: "CGNG", exchange: Exchange.ASX },
    { code: "CINPA", exchange: Exchange.ASX },
    { code: "CMIPB", exchange: Exchange.ASX },
    { code: "CMIPC", exchange: Exchange.ASX },
    { code: "CPUPA", exchange: Exchange.ASX },
    { code: "CRDG", exchange: Exchange.ASX },
    { code: "CSSG", exchange: Exchange.ASX },
    { code: "CTOG", exchange: Exchange.ASX },
    { code: "CVCG", exchange: Exchange.ASX },
    { code: "CWTPA", exchange: Exchange.ASX },
    { code: "DCFPA", exchange: Exchange.ASX },
    { code: "DCGAO", exchange: Exchange.ASX },
    { code: "DCGPA", exchange: Exchange.ASX },
    { code: "DJSPA", exchange: Exchange.ASX },
    { code: "DJWGA", exchange: Exchange.ASX },
    { code: "DRAG", exchange: Exchange.ASX },
    { code: "DVAG", exchange: Exchange.ASX },
    { code: "DXRPA", exchange: Exchange.ASX },
    { code: "DYNPA", exchange: Exchange.ASX },
    { code: "EBTG", exchange: Exchange.ASX },
    { code: "ECPGA", exchange: Exchange.ASX },
    { code: "ELDPA", exchange: Exchange.ASX },
    { code: "EMCG", exchange: Exchange.ASX },
    { code: "EPYG", exchange: Exchange.ASX },
    { code: "ETWG", exchange: Exchange.ASX },
    { code: "ETWPB", exchange: Exchange.ASX },
    { code: "FARG", exchange: Exchange.ASX },
    { code: "FARGA", exchange: Exchange.ASX },
    { code: "FCLGA", exchange: Exchange.ASX },
    { code: "FSIGA", exchange: Exchange.ASX },
    { code: "FWLAI", exchange: Exchange.ASX },
    { code: "FXJPA", exchange: Exchange.ASX },
    { code: "FXJPB", exchange: Exchange.ASX },
    { code: "GC1PA", exchange: Exchange.ASX },
    { code: "GFLGA", exchange: Exchange.ASX },
    { code: "GMPPA", exchange: Exchange.ASX },
    { code: "GNCPA", exchange: Exchange.ASX },
    { code: "GNSPA", exchange: Exchange.ASX },
    { code: "GOAG", exchange: Exchange.ASX },
    { code: "GOLD", exchange: Exchange.ASX },
    { code: "GTPG", exchange: Exchange.ASX },
    { code: "GTPGA", exchange: Exchange.ASX },
    { code: "GTPGB", exchange: Exchange.ASX },
    { code: "HGOG", exchange: Exchange.ASX },
    { code: "HLNG", exchange: Exchange.ASX },
    { code: "HLNGA", exchange: Exchange.ASX },
    { code: "HOMPA", exchange: Exchange.ASX },
    { code: "HSKG", exchange: Exchange.ASX },
    { code: "HTAG", exchange: Exchange.ASX },
    { code: "HTAPA", exchange: Exchange.ASX },
    { code: "IAGPA", exchange: Exchange.ASX },
    { code: "IAGPB", exchange: Exchange.ASX },
    { code: "IAGPC", exchange: Exchange.ASX },
    { code: "IAGPD", exchange: Exchange.ASX },
    { code: "IAGPE", exchange: Exchange.ASX },
    { code: "IAGPF", exchange: Exchange.ASX },
    { code: "IAN", exchange: Exchange.ASX },
    { code: "IANG", exchange: Exchange.ASX },
    { code: "ICUPA", exchange: Exchange.ASX },
    { code: "IDLG", exchange: Exchange.ASX },
    { code: "IIFG", exchange: Exchange.ASX },
    { code: "IVTPA", exchange: Exchange.ASX },
    { code: "JDOPA", exchange: Exchange.ASX },
    { code: "JYCAK", exchange: Exchange.ASX },
    { code: "KBCPA", exchange: Exchange.ASX },
    { code: "KBLGA", exchange: Exchange.ASX },
    { code: "KZLG", exchange: Exchange.ASX },
    { code: "LEIGA", exchange: Exchange.ASX },
    { code: "LFSPA", exchange: Exchange.ASX },
    { code: "LKOG", exchange: Exchange.ASX },
    { code: "LKOGA", exchange: Exchange.ASX },
    { code: "LKOGB", exchange: Exchange.ASX },
    { code: "LNGAO", exchange: Exchange.ASX },
    { code: "LRGG", exchange: Exchange.ASX },
    { code: "LRXG", exchange: Exchange.ASX },
    { code: "LRXGA", exchange: Exchange.ASX },
    { code: "LSBHA", exchange: Exchange.ASX },
    { code: "LSBHB", exchange: Exchange.ASX },
    { code: "LSBHC", exchange: Exchange.ASX },
    { code: "LSBHD", exchange: Exchange.ASX },
    { code: "LSBHE", exchange: Exchange.ASX },
    { code: "LSBHF", exchange: Exchange.ASX },
    { code: "LSBHG", exchange: Exchange.ASX },
    { code: "LSBHH", exchange: Exchange.ASX },
    { code: "MAZPA", exchange: Exchange.ASX },
    { code: "MAZPB", exchange: Exchange.ASX },
    { code: "MBLPA", exchange: Exchange.ASX },
    { code: "MBLPB", exchange: Exchange.ASX },
    { code: "MBLPC", exchange: Exchange.ASX },
    { code: "MBLPD", exchange: Exchange.ASX },
    { code: "MGAPA", exchange: Exchange.ASX },
    { code: "MHLAO", exchange: Exchange.ASX },
    { code: "MHLAQ", exchange: Exchange.ASX },
    { code: "MHLAY", exchange: Exchange.ASX },
    { code: "MMTPA", exchange: Exchange.ASX },
    { code: "MORPA", exchange: Exchange.ASX },
    { code: "MOZG", exchange: Exchange.ASX },
    { code: "MPBPA", exchange: Exchange.ASX },
    { code: "MPNPA", exchange: Exchange.ASX },
    { code: "MQCPA", exchange: Exchange.ASX },
    { code: "MQGPA", exchange: Exchange.ASX },
    { code: "MQGPB", exchange: Exchange.ASX },
    { code: "MQGPC", exchange: Exchange.ASX },
    { code: "MQGPD", exchange: Exchange.ASX },
    { code: "MQGPE", exchange: Exchange.ASX },
    { code: "MQGPF", exchange: Exchange.ASX },
    { code: "MQGPG", exchange: Exchange.ASX },
    { code: "MSCG", exchange: Exchange.ASX },
    { code: "MSCPA", exchange: Exchange.ASX },
    { code: "MSTG", exchange: Exchange.ASX },
    { code: "MSTGA", exchange: Exchange.ASX },
    { code: "MXUPA", exchange: Exchange.ASX },
    { code: "MYBG", exchange: Exchange.ASX },
    { code: "MYFG", exchange: Exchange.ASX },
    { code: "NABPA", exchange: Exchange.ASX },
    { code: "NABPB", exchange: Exchange.ASX },
    { code: "NABPC", exchange: Exchange.ASX },
    { code: "NABPD", exchange: Exchange.ASX },
    { code: "NABPE", exchange: Exchange.ASX },
    { code: "NABPF", exchange: Exchange.ASX },
    { code: "NABPG", exchange: Exchange.ASX },
    { code: "NABPH", exchange: Exchange.ASX },
    { code: "NABPI", exchange: Exchange.ASX },
    { code: "NABPJ", exchange: Exchange.ASX },
    { code: "NABPK", exchange: Exchange.ASX },
    { code: "NACGA", exchange: Exchange.ASX },
    { code: "NCCGA", exchange: Exchange.ASX },
    { code: "NFNG", exchange: Exchange.ASX },
    { code: "NHRG", exchange: Exchange.ASX },
    { code: "NLXG", exchange: Exchange.ASX },
    { code: "NMGG", exchange: Exchange.ASX },
    { code: "NSCG", exchange: Exchange.ASX },
    { code: "OBLG", exchange: Exchange.ASX },
    { code: "OCVG", exchange: Exchange.ASX },
    { code: "ORIPB", exchange: Exchange.ASX },
    { code: "P25PA", exchange: Exchange.ASX },
    { code: "PCAPA", exchange: Exchange.ASX },
    { code: "PCBPA", exchange: Exchange.ASX },
    { code: "PLFGB", exchange: Exchange.ASX },
    { code: "PMNPA", exchange: Exchange.ASX },
    { code: "PPCG", exchange: Exchange.ASX },
    { code: "PRKG", exchange: Exchange.ASX },
    { code: "PWSPA", exchange: Exchange.ASX },
    { code: "PXUPA", exchange: Exchange.ASX },
    { code: "RHCPA", exchange: Exchange.ASX },
    { code: "RSGG", exchange: Exchange.ASX },
    { code: "RSNG", exchange: Exchange.ASX },
    { code: "RSNGB", exchange: Exchange.ASX },
    { code: "RSNGC", exchange: Exchange.ASX },
    { code: "SBCPA", exchange: Exchange.ASX },
    { code: "SBKPA", exchange: Exchange.ASX },
    { code: "SBKPB", exchange: Exchange.ASX },
    { code: "SEKG", exchange: Exchange.ASX },
    { code: "SELG", exchange: Exchange.ASX },
    { code: "SEVPC", exchange: Exchange.ASX },
    { code: "SGBPA", exchange: Exchange.ASX },
    { code: "SGBPC", exchange: Exchange.ASX },
    { code: "SGBPD", exchange: Exchange.ASX },
    { code: "SGBPE", exchange: Exchange.ASX },
    { code: "SGLG", exchange: Exchange.ASX },
    { code: "SGLGA", exchange: Exchange.ASX },
    { code: "SHGG", exchange: Exchange.ASX },
    { code: "SIVG", exchange: Exchange.ASX },
    { code: "SKAG", exchange: Exchange.ASX },
    { code: "SKSG", exchange: Exchange.ASX },
    { code: "SRAG", exchange: Exchange.ASX },
    { code: "SSLPA", exchange: Exchange.ASX },
    { code: "SSSPA", exchange: Exchange.ASX },
    { code: "SSXPB", exchange: Exchange.ASX },
    { code: "STOPB", exchange: Exchange.ASX },
    { code: "STSG", exchange: Exchange.ASX },
    { code: "SUNPC", exchange: Exchange.ASX },
    { code: "SUNPD", exchange: Exchange.ASX },
    { code: "SUNPE", exchange: Exchange.ASX },
    { code: "SUNPF", exchange: Exchange.ASX },
    { code: "SUNPG", exchange: Exchange.ASX },
    { code: "SUNPH", exchange: Exchange.ASX },
    { code: "SUNPI", exchange: Exchange.ASX },
    { code: "SUNPJ", exchange: Exchange.ASX },
    { code: "SURG", exchange: Exchange.ASX },
    { code: "SVWPA", exchange: Exchange.ASX },
    { code: "SWMG", exchange: Exchange.ASX },
    { code: "TCSPA", exchange: Exchange.ASX },
    { code: "TDRG", exchange: Exchange.ASX },
    { code: "TESPA", exchange: Exchange.ASX },
    { code: "TIMG", exchange: Exchange.ASX },
    { code: "TIMPA", exchange: Exchange.ASX },
    { code: "TIMPB", exchange: Exchange.ASX },
    { code: "TOLPA", exchange: Exchange.ASX },
    { code: "TPAPA", exchange: Exchange.ASX },
    { code: "TPAPC", exchange: Exchange.ASX },
    { code: "TTXPA", exchange: Exchange.ASX },
    { code: "URFPA", exchange: Exchange.ASX },
    { code: "VELPA", exchange: Exchange.ASX },
    { code: "VHLG", exchange: Exchange.ASX },
    { code: "VHLGA", exchange: Exchange.ASX },
    { code: "VIEAS", exchange: Exchange.ASX },
    { code: "VSLG", exchange: Exchange.ASX },
    { code: "WASPA", exchange: Exchange.ASX },
    { code: "WBAPA", exchange: Exchange.ASX },
    { code: "WBBPB", exchange: Exchange.ASX },
    { code: "WBCPA", exchange: Exchange.ASX },
    { code: "WBCPB", exchange: Exchange.ASX },
    { code: "WBCPC", exchange: Exchange.ASX },
    { code: "WBCPD", exchange: Exchange.ASX },
    { code: "WBCPE", exchange: Exchange.ASX },
    { code: "WBCPF", exchange: Exchange.ASX },
    { code: "WBCPG", exchange: Exchange.ASX },
    { code: "WBCPH", exchange: Exchange.ASX },
    { code: "WBCPI", exchange: Exchange.ASX },
    { code: "WBCPJ", exchange: Exchange.ASX },
    { code: "WBCPK", exchange: Exchange.ASX },
    { code: "WBCPL", exchange: Exchange.ASX },
    { code: "WBCPM", exchange: Exchange.ASX },
    { code: "WBKPA", exchange: Exchange.ASX },
    { code: "WCTPA", exchange: Exchange.ASX },
    { code: "WFLPA", exchange: Exchange.ASX },
    { code: "WHFPA", exchange: Exchange.ASX },
    { code: "WHFPB", exchange: Exchange.ASX },
    { code: "YCNPA", exchange: Exchange.ASX },
    { code: "ZZFG", exchange: Exchange.ASX }
];
